import { FC, useState } from 'react';
import { NudosButton } from 'components/NudosComponents';
import NudosConfirmActionModal from 'components/NudosComponents/NudosConfirmActionModal/NudosConfirmActionModal';
import './ActionButtons.scss';

const ActionButtons: FC<ActionButtonsProps> = ({ onCancel, onSave, isLoading, disabled }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmSave = () => {
    setIsModalOpen(false);
    onSave();
  };

  return (
    <>
      <div className="actionButtons">
        <NudosButton
          colorPalette="secondary"
          buttonText="Cancelar modificación"
          handleClick={onCancel}
          isButtonDisabled={disabled || isLoading}
          customWidth="148px"
          customHeight="38px"
        />
        <NudosButton
          colorPalette="primary"
          buttonText="Aplicar modificación"
          handleClick={handleOpenModal}
          isButtonLoading={isLoading}
          isButtonDisabled={disabled}
          customWidth="148px"
          customHeight="38px"
        />
      </div>

      {isModalOpen && (
        <NudosConfirmActionModal
          modalText="Al modificar la información de la herramienta, los cambios se actualizarán en WMS. ¿Deseas continuar?"
          firstButtonText="No, regresar"
          secondButtonText="Sí, aplicar modificación"
          firstButtonAction={handleCloseModal}
          secondButtonAction={handleConfirmSave}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

interface ActionButtonsProps {
  onCancel: () => void;
  onSave: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export default ActionButtons;
